import React, { useState, useEffect } from "react";

const Slider = () => {
  const images = [
    // "./images/pic-3.jpeg",
    "./images/simage-1.jpeg",
    "./images/simage-2.jpeg",
    "./images/simage-3.jpeg",
    // "./images/pic-2.jpeg",
    // "./images/pic-4.jpeg"
    // "./images/pic-6.jpeg"
  ];

  const mobimages = [
   
    // "./images/slider-mob-1.jpg",
    // "./images/slider-mob-1.jpg",
     "./images/simage-1.jpeg",
    "./images/simage-2.jpeg",
    "./images/simage-3.jpeg",
  ];

  const [current, setCurrent] = useState(0);

  // Auto-play (slow down here)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 6000);  // ⬅ Change this value (6000 = 6 seconds)

    return () => clearInterval(interval);
  }, [images.length]);

  const nextSlide = () => {
    setCurrent((current + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrent((current - 1 + images.length) % images.length);
  };

  return (
    <div className="slider" style={{ width: "100%",marginTop:'-50px'}}>
      {/* <button className="prev" onClick={prevSlide}>❮</button> */}

      <div className="slide-image" style={{backgroundImage: `url(${images[current]})`, width: '100%', height: '100vh', backgroundSize: 'cover', backgroundPosition: 'center',display:'flex',alignItems:'end',justifyContent:'center'}}>
        
                {/* <img src="./images/temple.png" style={{ width: "40%" }} alt="logo" /> */}
           
      </div>
      <div className="mob-slide-image" style={{backgroundImage: `url(${images[current]})`, width: '100%', height: '100vh', backgroundSize: 'cover', backgroundPosition: 'center'}}></div>

      {/* <img
        src={images[current]}
        alt="Slider"
        className="slide-image"
        style={{ width: "100%" }}
      /> */}

       {/* <img
        src={mobimages[current]}
        alt="Slider"
        className="mob-slide-image"
        style={{ width: "100%" }}
      /> */}

      {/* <button className="next" onClick={nextSlide}>❯</button> */}
    </div>

    
  );
};

export default Slider;
